import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useContext, Children } from 'react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { TimedElementContext } from '../../TimedElement.context';
var ACTION_SHOW = 'show';
var ACTION_HIDE = 'hide';
var defaultProps = {
  action: ACTION_HIDE
};
export default function ActionComponent(_ref) {
  var children = _ref.children,
    action = _ref.action,
    passThroughActionProp = _ref.passThroughActionProp;
  var _useContext = useContext(TimedElementContext),
    setShownInSession = _useContext.setShownInSession,
    forceShow = _useContext.forceShow;
  var actionHandler = action === ACTION_SHOW ? forceShow : setShownInSession;
  if (Children.count(children) === 0) {
    return null;
  }
  var child = Children.toArray(children)[0];
  return /*#__PURE__*/React.cloneElement(child, _defineProperty({}, passThroughActionProp, actionHandler));
}
ActionComponent.defaultProps = defaultProps;